export default __webpack_public_path__ + "static/media/icon-email-hosting-round.5ff9b539.svg";